// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { Spinner, Section, Skeleton } from '@loa/ui-components';

export function ProviderAccessLoading() {
  return (
    <Section>
      <Spinner />
      <div style={{ marginTop: '2rem' }}>
        <Skeleton variant="header" />
        <Skeleton variant="paragraph" lines={3} />
      </div>
    </Section>
  );
}
